export default "/react/logoChatHelper-67b68e14.png";